angular.module('zc.projects')

.directive 'zcCampaignInterestWidgetConversionPriceGraph', ($translate, BaseCampaignInterestWidgetGraph, Chart, currencies) ->
  class Graph extends BaseCampaignInterestWidgetGraph
    link: (scope, element, attrs) ->
      scope.currency = currencies[scope.project.currency]

      addSeries = (cumulative_conversion_price_stats) ->
        scope.chartConfig.series = [
          name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetConversionPriceGraph.acquisitionAmount')
          data: cumulative_conversion_price_stats
        ]

      scope.getStats = ->
        scope.getCampaignEventStats('click_item')

      scope.getChartConfig = ->
        scope.chartConfig = Chart.getChartConfig 'segment',
          options:
            tooltip:
              valueSuffix: scope.currency.suffix
              valueDecimals: scope.currency.fractionSize
            legend: false

      scope.addChartConfig = (campaign_event_stats) ->
        return if !campaign_event_stats || campaign_event_stats.length == 0

        cumulative_conversion_price = 0
        cumulative_conversion_price_stats = [[campaign_event_stats[0].start_at.valueOf(), 0]]
        for stats in campaign_event_stats
          cumulative_conversion_price += stats.conversion_price
          cumulative_conversion_price_stats.push [stats.end_at.valueOf(), cumulative_conversion_price]
        addSeries(cumulative_conversion_price_stats)

  return new Graph('daily').createDirective()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_interest_widget_conversion_price_graph.coffee